<template>
  <div class="animated fadeIn step-container plan-payment">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <h2 class="text-center">สมัครแพลนการใช้งาน</h2>
      </div>
      <div class="col-md-8 offset-md-2">
        <step :currentStep="1" :maxStep="3" @step_clicked='gotoPage'>
          <div slot='1'>กรอกรายละเอียด</div>
          <div slot='2'>การชำระเงิน</div>
          <div slot='3'>ยืนยัน</div>
        </step>
      </div>
      <div class="col-md-8 offset-md-2 step-body">
        <h4 class="step-header">รายละเอียดบริการ</h4>
        <div class="row">
          <div class="col-12">
            <h6></h6>
          </div>
          <div class="col-12">
            <table class="table">
              <thead>
                <tr>
                  <th>Detail</th>
                  <th>ระยะเวลา</th>
                  <th>ราคา</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <p>
                      <strong>{{selectedPlan.name}} </strong>
                      <br> 
                      {{selectedPlan.detail}}
                    </p>
                  </td>
                  <td>{{selectedPlan.duration}}</td>
                  <td>฿{{selectedPlan.price | formatNumber}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td>ค่าธรรมเนียม (3.8%)</td>
                  <td>฿{{creditCardFee | formatNumber}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td>รวมทั้งหมด</td>
                  <td>฿{{selectedPlan.price + creditCardFee | formatNumber}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-6 form-group text-left">
            <router-link class="btn btn-link btn-lg" :to="'/package'"><i class="fa fa-arrow-circle-o-left" aria-hidden="true"></i> {{$t('action_message.back')}}</router-link>
            
          </div>
          <div class="col-6 form-group text-right">
            <router-link class="btn btn-store btn-lg" :to="step2Link + addAppParams">ต่อไป <i class="fa fa-angle-right" aria-hidden="true"></i></router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Step from '@/components/StepBar'

export default {
  components: {
    Step
  },
  data () {
    return {
      selectedPlan: {},
      plans: [
        {
          id: 1,
          name: 'Basic Plan (subscription)',
          detail: '499 (per month) x 3 months',
          duration: '3 เดือน',
          price: 1497
        },
        {
          id: 2,
          name: 'Advance Plan (subscription)',
          detail: '฿399 (per month) x 12 months',
          duration: '1 ปี',
          price: 4788
        },
        {
          id: 3,
          name: 'Pro Plan (subscription)',
          detail: '฿299 (per month) x 36 months',
          duration: '3 ปี',
          price: 10764
        }
      ]
    }
  },
  mounted () {
    if (this.$route.query.plan_id &&
    this.$route.query.plan_id > 0 &&
    this.$route.query.plan_id <= 3) {
      this.selectedPlan = this.plans[parseInt(this.$route.query.plan_id) - 1]
    } else {
      this.selectedPlan = this.plans[0]
    }
  },
  computed: {
    step2Link () {
      return '/package/payment/step2?plan_id=' + this.selectedPlan.id
    },
    addAppParams () {
      if (this.$route.query.app !== null && this.$route.query.app !== undefined) {
        return '&app=' + this.$route.query.app
      }
      return ''
    },
    creditCardFee () {
      if (typeof this.selectedPlan.price === 'undefined') {
        return 0
      }
      return parseInt(this.selectedPlan.price * 0.038)
    }
  }
}
</script>

<style lang='scss'>
@import "../../../assets/base_container";
.plan-payment{
  table{
    border-bottom: 1px #cfd8dc solid;
  }
}
.step-body{
  background-color: #fff;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// step1.vue?30898bbc